import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695cd1737683ed00149363b7/samkit_agro_corporate/node_modules/next/dist/client/components/render-from-template-context.js");
